import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { TypedMemo } from '../../../common/types';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { rolloutMessages } from '../releases/plan/rollout/rolloutMessages';
import { ComposerPostingModes } from './composerPostingModes';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

const messages = defineMessages({
  pickedNoneConnected: {
    id: 'app.sml.promote.composer.timing.allReminders',
    defaultMessage:
      'No picked channel is connected, so no post goes out by itself. Each post comes to you as a "post it yourself" reminder at its time.',
  },
});

interface ComposerRemindersNoteProps {
  modes: ComposerPostingModes;
}

/**
 * In the Timing section, when no picked channel posts by itself (QA finding B11): every post of
 * this set comes as a "post it yourself" reminder at its time, and "Connect a channel" opens
 * Channels. Nothing shows while a picked channel posts by itself, or while no channel is picked.
 */
const ComposerRemindersNoteComponent: React.FC<ComposerRemindersNoteProps> = ({ modes }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const openChannels = useCallback(() => router.push(SMLRoutes.promoteChannels), [router]);

  if (modes.auto.length > 0 || modes.manual.length === 0) {
    return null;
  }
  return (
    <p className={styles.planNote} data-testid="composer-reminders-note">
      <FontAwesomeIcon icon={faBell} />
      <span>
        {intl.formatMessage(modes.noneConnected ? rolloutMessages.channelsNoneConnected : messages.pickedNoneConnected)}{' '}
        <button type="button" className="btn btn-link p-0 align-baseline" onClick={openChannels}>
          {intl.formatMessage(rolloutMessages.connectChannel)}
        </button>
      </span>
    </p>
  );
};

export const ComposerRemindersNote = TypedMemo(ComposerRemindersNoteComponent);
